import React, { type ButtonHTMLAttributes } from 'react'
import cn from 'classnames'
import { Play } from 'lucide-react'
import styles from './media-play-button.module.scss'

interface MediaPlayButtonProps
    extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'type'> {
    'aria-label': string
}

export default function MediaPlayButton({ className, ...buttonProps }: MediaPlayButtonProps) {
    return (
        <button type="button" className={cn(styles.mediaPlayButton, className)} {...buttonProps}>
            <Play size={26} strokeWidth={2.4} aria-hidden="true" />
        </button>
    )
}
